import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Home from '@/pages/Home'
import PageNotFound from '@/pages/PageNotFound'

import AboutTheHukos from './about-the-hukos'
import AboutTheWorld from './about-the-world'
import Author from './author'
import LegalCredits from './legal-credits'

const waitForStorageToBeReady = async (to, from, next) => {
	await store.restored
	next()
}

Vue.use(Router)

const router = new Router({
	mode  : 'history',
	routes: [
		{
			path     : '/',
			name     : 'Home',
			component: Home,
			meta     : { area: 'home' }
		},
		AboutTheHukos,
		AboutTheWorld,
		Author,
		LegalCredits,

		{ path: '*', component: PageNotFound }
	]
})

router.beforeEach(waitForStorageToBeReady)
export default router
